import { useContext } from "react";
import AuthContext from "../contexts/AuthContext";
import { getFeatureFlags, hasFeatureFlag } from "../utils/tokenUtils";

/**
 * Hook to get feature flags from the current user's token
 * @returns {Object} Object with feature flag utilities
 */
export function useFeatureFlags() {
  const { authTokens } = useContext(AuthContext);

  return {
    // Get all feature flags
    flags: getFeatureFlags(authTokens),

    // Check if a specific flag is enabled
    hasFlag: (flag) => hasFeatureFlag(authTokens, flag),

    // Check if wave 2 is enabled (convenience method)
    hasWave2: () => hasFeatureFlag(authTokens, "lego-wave-2"),
  };
}
